<app-header-page>
    <app-component-button-header-back href="/account/options/departments">
        {{ 'HEADERS.DEPARTMENTS_LIST' | translate }}
    </app-component-button-header-back>
</app-header-page>

<div *ngIf="departmentDetails">
    <div class="content p-4 allTable">
        <h2 *ngIf="!currentMember.project_setting.is_project_admin && !canEdit">
            {{ departmentDetails.name }}
        </h2>
        <h2>
            <app-component-input-inline (emitSave)="onEditDepartment($event)"
                                        *ngIf="canEdit || currentMember.project_setting.is_project_admin"
                                        [value]="departmentDetails.name">
            </app-component-input-inline>
        </h2>
        <div class="super__tabs mb-4 ">
            <div (click)="tab = 'divisions'"
                 [class.active]="tab === 'divisions'"
                 class="super__tabs tab"
                 data-action="divisions"
            >
                <span>{{ 'DEPARTMENTS.TEXT.DIVISIONS' | translate }}</span>
            </div>
            <!--			<div class="super__tabs tab"-->
            <!--			     data-action="access"-->
            <!--			     (click)="tab = 'rights'"-->
            <!--			     [class.active]="tab === 'rights'"-->
            <!--			>-->
            <!--				<span>Список прав</span>-->
            <!--			</div>-->
            <div (click)="tab = 'users'"
                 [class.active]="tab === 'users'"
                 class="super__tabs tab"
                 data-action="members"
            >
                <span>{{ 'DEPARTMENTS.TEXT.MEMBERS' | translate }}</span>
            </div>
        </div>
    </div>

    <ng-container *ngIf="tab === 'divisions'">
        <ng-container *ngTemplateOutlet="divisions"></ng-container>
    </ng-container>
    <ng-container *ngIf="tab === 'users'">
        <ng-container *ngTemplateOutlet="users"></ng-container>
    </ng-container>
    <!--	<ng-container *ngIf="tab === 'rights'">-->
    <!--		<ng-container *ngTemplateOutlet="rights"></ng-container>-->
    <!--	</ng-container>-->
</div>

<ng-template #divisions>
    <div>
        <button (click)="setDivisionIdAndOpenModal(createDivisionModal)"
                class="btn btn-primary btn-sm mb-4"
                data-action="addDivision"
        >
            <span>{{ 'DEPARTMENTS.BUTTONS.DIVISION' | translate }}</span>
        </button>
    </div>

    <div class="card flex justify-content-center division-container">
        <div *ngFor="let divisionItem of departmentDivisions" class="division-item">
            <ng-container *ngTemplateOutlet="division; context: {divisionItem: divisionItem}"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #division let-divisionItem="divisionItem">
    <div>
        <div [class.error]="!divisionItem.subdivision.length && !divisionItem.member_guids.length"
             [ngbTooltip]="!divisionItem.subdivision.length && !divisionItem.member_guids.length ? ('EMPTY_LISTS.DIVISION' | translate) : ''"
             class="division-item item-head flex-display justify-content-between"
        >
            <div>
                <i (click)="divisionSlider[divisionItem.id] = !divisionSlider[divisionItem.id]"
                   *ngIf="divisionItem.subdivision.length || divisionItem.member_guids.length"
                   [class]="divisionSlider[divisionItem.id] ? 'bi bi-caret-down me-5px pointer' : 'bi bi-caret-right me-5px pointer'"
                ></i>
                <i class="bi-people me-5px"
                   ngbTooltip="{{ 'DEPARTMENTS.TEXT.DIVISION' | translate }}"
                ></i>
                <span>{{ divisionItem.name }}</span>
            </div>
            <div>
                <i (click)="setDivisionIdAndOpenModal(createDivisionModal, divisionItem.id)"
                   class="bi bi-plus me-5px pointer"
                   ngbTooltip="{{ 'DEPARTMENTS.BUTTONS.SUBDIVISION' | translate }}"
                ></i>
                <i (click)="setDivisionIdAndOpenModal(addMemberModal, divisionItem.id)"
                   class="bi bi-person-add me-5px pointer"
                   ngbTooltip="{{ 'DEPARTMENTS.BUTTONS.ADD_MEMBER' | translate }}"
                ></i>
                <i (click)="setDivisionIdAndOpenModal(editDivisionModal, divisionItem.id)"
                   class="bi bi-pen me-5px pointer"
                   ngbTooltip="{{ 'DEPARTMENTS.BUTTONS.EDIT_NAME' | translate }}"
                ></i>
                <i (click)="deleteDivision(divisionItem)"
                   class="bi bi-trash text-danger me-5px pointer"
                   ngbTooltip="{{ 'DEPARTMENTS.BUTTONS.DELETE' | translate }}"
                ></i>
            </div>
        </div>

        <div *ngIf="divisionSlider[divisionItem.id]">
            <div *ngFor="let member of divisionItem.member_guids"
                 class="division-members flex-display justify-content-between"
            >
                <div>
                    <i class="bi bi-person me-5px"></i>
                    <span (click)="helper.openProfileByGuid(divisionsMembers[member].guid)"
                          class="user_name"
                    >
						{{ helper.shortFullName(divisionsMembers[member]) }}
					</span>
                </div>
                <div>
                    <i (click)="deleteMemberFromDivision(member, divisionItem)"
                       class="bi bi-trash text-danger me-5px pointer"
                       ngbTooltip="{{ 'DEPARTMENTS.BUTTONS.DELETE_MEMBER' | translate }}"
                    ></i>
                </div>
            </div>

            <div *ngFor="let divisionItem of divisionItem.subdivision" class="subdivision">
                <ng-container *ngTemplateOutlet="division; context: {divisionItem: divisionItem}"></ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #users>
    <div>
        <button (click)="onAddMember()"
                class="btn btn-primary btn-sm mb-4"
                data-action="addMemberToDepartment"
        >
            <span>{{ 'DEPARTMENTS.BUTTONS.INVITE' | translate }}</span>
        </button>

        <table class="table default-table table-tasks">
            <thead>
            <tr>
                <th>{{ 'DEPARTMENTS.TITLE.FULL_NAME' | translate }}</th>
                <th>{{ 'DEPARTMENTS.TITLE.EMAIL' | translate }}</th>
                <!--				<th>{{ 'DEPARTMENTS.TITLE.ADMIN' | translate }}</th>-->
                <th class="col-small"></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngIf="loading">
                <td colspan="3">
                    <div class="donut blue"></div>
                </td>
            </tr>
            <tr *ngIf="!loading && !departmentUsers.length">
                <td colspan="3">
                    <b>
                        {{ 'EMPTY_LISTS.MEMBERS' | translate }}
                    </b>
                </td>
            </tr>
            <tr *ngFor="let user of departmentUsers; let i = index"
                [attr.data-member-index]="i"
            >
                <td>
                    <span (click)="helper.openProfileByGuid(user.member.guid)"
                          [class.blocked_user]="user.member.project_setting.observation_type === 'blocked'"
                          [class.inactive_user]="!user.member.is_active"
                          class="user_profile"
                          data-action="openProfile"
                    >
                        {{ helper.fullName(user.member) }}
                    </span>
                </td>
                <td>{{ user.member.email }}</td>
                <td class="stat__col">
                    <!--                <span (click)="setDepartmentAdmin(user)"-->
                    <!--                      data-action="setDepartmentAdmin"-->
                    <!--                      class="stat__col__icon admin"-->
                    <!--                      [class.admin]="currentMember.project_setting.is_project_admin || currentDepAdmin.is_department_admin"-->
                    <!--                      [class.active]="user.is_department_admin"-->
                    <!--                >-->
                    <!--                    {{user.is_department_admin ? '&#10004;' : '&#10006;'}}-->
                    <!--                </span>-->
                </td>
                <td>
                    <button (click)="removeUserFromDepartment(user)"
                            [disabled]="isLockGroupButton[i]"
                            class="btn btn-danger btn-sm delete"
                            data-action="deleteUser"
                    >
                        <span *ngIf="!isLockGroupButton[i] else refresh">&times; {{ 'BUTTON_TEXT.DELETE' | translate }}</span>
                    </button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</ng-template>

<ng-template #inviteMemberView let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1>{{ 'MODALS.HEADERS.ADD_MEMBER' | translate }}</h1>

        <small>{{ 'MODALS.TEXT.DEP_ALERT' | translate }}</small>

        <h2>{{ 'MODALS.FIELDS.MEMBER' | translate }}:</h2>
        <select #userMail class="form-select" required>
            <option *ngIf="!usersInProject.length" disabled>{{ 'EMPTY_LISTS.EMPTY' | translate }}.</option>
            <option *ngFor="let user of usersInProject"
                    [class.inactive_user]="!user.is_active"
                    value="{{user.email}}"
            >
                {{ helper.fullName(user) }}
            </option>
        </select>

        <h3>{{ 'MODALS.FIELDS.SELECT.PERMISSIONS.PERMISSION' | translate }}:</h3>
        <select #rights class="form-select" required>
            <option hidden selected value=""> {{ 'MODALS.FIELDS.SELECT.PERMISSIONS.SELECT' | translate }}</option>
            <option value="inner"> {{ 'MODALS.FIELDS.SELECT.PERMISSIONS.INNER' | translate }}</option>
            <option value="outer"> {{ 'MODALS.FIELDS.SELECT.PERMISSIONS.OUTER' | translate }}</option>
            <!--			<option value="admin"> {{ 'MODALS.FIELDS.SELECT.PERMISSIONS.DEP_ADMIN' | translate }}</option>-->
        </select>

        <button (click)="sendInviteToDepartment(rights.value, userMail.value, modal)"
                [disabled]="isLockButton"
                class="btn btn-success"
                data-action="addMemberButton"
                style="margin-top: 15px;"
        >
            <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.ADD' | translate }}</span>
        </button>
    </div>
</ng-template>

<!--<ng-template #changeUserRightsView let-modal>-->
<!--	<app-button-modal-close [modal]="modal"></app-button-modal-close>-->
<!--	<div class="modal-body">-->
<!--		<h1>Изменить права</h1>-->

<!--		<h3>Права доступа:</h3>-->
<!--		<select #rights required>-->
<!--			<option value="" hidden>Выберите тип прав</option>-->
<!--			<option value="read"> Чтение</option>-->
<!--			<option value="edit"> Изменение</option>-->
<!--			<option value="sign" *ngIf="!selectedRow.board_id"> Подпись</option>-->
<!--		</select>-->

<!--		<button style="margin-top: 15px;"-->
<!--		        data-action="changeRowButton"-->
<!--		        class="btn btn-success"-->
<!--		        [disabled]="isLockButton"-->
<!--		        (click)="changeRowRights(rights.value, modal)"-->
<!--		>-->
<!--			<span *ngIf="!isLockButton else refresh">Изменить</span>-->
<!--		</button>-->
<!--	</div>-->
<!--</ng-template>-->

<!--<ng-template #addRulesView let-modal>-->
<!--	<app-button-modal-close [modal]="modal"></app-button-modal-close>-->
<!--	<div class="modal-body">-->
<!--		<h1>Добавление прав департамента</h1>-->
<!--		<h2>Поиск коллекции, папки или файла</h2>-->
<!--		<app-component-search-query-->
<!--				(data)="searchRes = $event"-->
<!--		></app-component-search-query>-->
<!--		<h2>Установка прав:</h2>-->
<!--		<select #roles>-->
<!--			<option value="" hidden selected>Выбрать права</option>-->
<!--			<option value="read">Чтение</option>-->
<!--			<option value="edit">Изменение</option>-->
<!--			<option value="sign">Подпись</option>-->
<!--		</select>-->
<!--		<button class="btn btn-success"-->
<!--		        data-action="addRowButton"-->
<!--		        style="margin-top: 15px;"-->
<!--		        [disabled]="isLockButton"-->
<!--		        (click)="addRights(roles.value, modal);"-->
<!--		>-->
<!--			<span *ngIf="!isLockButton else refresh">Добавить</span>-->
<!--		</button>-->
<!--	</div>-->
<!--</ng-template>-->

<ng-template #createDivisionModal let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1>{{ 'MODALS.HEADERS.DIVISION' | translate }}</h1>

        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
        <input #divisionName class="form-control">

        <button (click)="createDivision(divisionName.value, modal)"
                class="btn btn-success"
                data-action="createDivisionInDepartment"
                style="margin-top: 15px;"
        >
            <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.CREATE' | translate }}</span>
        </button>
    </div>
</ng-template>

<ng-template #editDivisionModal let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1>{{ 'MODALS.HEADERS.EDIT_DIVISION' | translate }}</h1>

        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
        <input #divisionName class="form-control">

        <button (click)="editDivision(divisionName.value, modal)"
                class="btn btn-success"
                data-action="createDivisionInDepartment"
                style="margin-top: 15px;"
        >
            <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.EDIT' | translate }}</span>
        </button>
    </div>
</ng-template>

<ng-template #addMemberModal let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1>{{ 'MODALS.HEADERS.ADD_MEMBER' | translate }}</h1>

        <small>{{ 'MODALS.TEXT.DIV_ALERT' | translate }}</small>

        <h2>{{ 'MODALS.FIELDS.MEMBER' | translate }}:</h2>
        <select #userMail class="form-select" required>
            <option *ngIf="!usersInProject.length" disabled>{{ 'EMPTY_LISTS.EMPTY' | translate }}.</option>
            <option *ngFor="let user of usersInProject"
                    [class.inactive_user]="!user.is_active"
                    value="{{user.email}}"
            >
                {{ helper.fullName(user) }}
            </option>
        </select>

        <button (click)="addMemberToDivision(userMail.value, modal)"
                class="btn btn-success"
                data-action="addMemberToDivision"
                style="margin-top: 15px;"
        >
            <span>{{ 'MODALS.BUTTONS.ADD' | translate }}</span>
        </button>
    </div>
</ng-template>

<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>
